$(function(){

    // init center carousel on active tab
    initCarousel('.LpWoundsCenterTab.active .LpWoundsCenterCarousel');

    // centers mobile select 2 init
    const $LpWoundsCenterSwitchSelect = $('.LpWoundsCenterSwitchSelect');
    $LpWoundsCenterSwitchSelect.select2({
        language: 'cs',
        width: '100%',
        tags: false,
        minimumResultsForSearch: 10,
        theme: 'LpWoundsCenterSwitchSelectJs'
    });

    // selection changed

    // select2 changed manually, switch tabs
    $LpWoundsCenterSwitchSelect.on('change', function (e) {
        let newValue =  $LpWoundsCenterSwitchSelect.val();
        changeCenterTab(newValue);
    });

    // button click
    $('.LpWoundsCenterSwitchButton').on('click', function(e){
        e.preventDefault();
        let newValue = $(e.target).data('center-id');
        changeCenterTab(newValue);
    });

    function changeCenterTab(tabID){
        // if we don't have id or tab with this id doesnt exist, return
        if ( !tabID || !$(`.LpWoundsCenterTab[data-center-id="${tabID}"]`).length ){
            return;
        }

        // destroy current carousel
        $('.LpWoundsCenterTab.active .LpWoundsCenterCarousel').trigger('destroy.owl.carousel');

        // switch tabs
        $('.LpWoundsCenterTab.active').removeClass('active');
        $(`.LpWoundsCenterTab[data-center-id="${tabID}"]`).addClass('active');

        // reinit current carousel
        initCarousel('.LpWoundsCenterTab.active .LpWoundsCenterCarousel');

        // change active class on button
        $('.LpWoundsCenterSwitchButton.LpWoundsCenterSwitchButton--active').removeClass('LpWoundsCenterSwitchButton--active');
        $(`.LpWoundsCenterSwitchButton[data-center-id="${tabID}"]`).addClass('LpWoundsCenterSwitchButton--active');

        // trigger select2 change
        $LpWoundsCenterSwitchSelect.val(tabID).trigger("change.select2");
    }

    function initCarousel(selector = '.LpWoundsCenterTab.active .LpWoundsCenterCarousel'){
        let $elem = $(selector);

        if ( $elem.length ){
            $elem.owlCarousel({
                loop: true,
                nav: false,
                dots: false,
                items: 1,
                margin: 15,
                autoplay: true
            });
        }
    }

});